export const emailType = process.env.VUE_APP_API_AREA;

export const userPoolData = {
  UserPoolId: process.env.VUE_APP_USER_POOLID,
  ClientId: process.env.VUE_APP_CLIENT_ID,
};
